"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineGfaServiceConfigProvider = void 0;
function defineGfaServiceConfigProvider(config) {
    return {
        id: 'gfa:service-config-provider',
        create: () => ({
            '1.0.0': () => ({ featureService: config }),
        }),
    };
}
exports.defineGfaServiceConfigProvider = defineGfaServiceConfigProvider;
//# sourceMappingURL=index.js.map